import Mutations from '../../odata/mutations';

export default { ...new Mutations('agreementAttachment'), ...new Mutations('agreementAttachments') };
